function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
import React, { useCallback } from 'react';
import { Button, Center, Flex, Icon, IconButton, icons, Menu, MenuButton, MenuItemOption, MenuList, MenuOptionGroup, Stack, Text } from '@tapresearch/ui/components';
export var QuestionItemComparisons = function(param) {
    var _param_comparisonQuestions = _sliced_to_array(param.comparisonQuestions, 2), demographicQuestions = _param_comparisonQuestions[0], comparableTapQuestions = _param_comparisonQuestions[1], _param_compareState = _sliced_to_array(param.compareState, 2), tmp = _param_compareState[0], crossTabQuestionId = tmp === void 0 ? null : tmp, setCrossTabQuestionId = _param_compareState[1], tapQuestionId = param.tapQuestionId;
    var handleChangeCrossTab = useCallback(function(val) {
        return setCrossTabQuestionId(val);
    }, [
        setCrossTabQuestionId
    ]);
    return /*#__PURE__*/ React.createElement(Stack, {
        direction: {
            base: 'column',
            md: 'row'
        },
        w: 'full',
        maxW: {
            base: 'none',
            md: 'calc(100% - 260px)'
        },
        spacing: 4,
        flexGrow: 1
    }, /*#__PURE__*/ React.createElement(CompareSelect, {
        demographicQuestions: demographicQuestions,
        onChange: handleChangeCrossTab,
        currentValue: crossTabQuestionId
    }), /*#__PURE__*/ React.createElement(CompareSelect, {
        tapQuestions: comparableTapQuestions,
        tapQuestionId: tapQuestionId,
        onChange: handleChangeCrossTab,
        currentValue: crossTabQuestionId
    }));
};
var CompareSelect = function(param) {
    var demographicQuestions = param.demographicQuestions, tapQuestions = param.tapQuestions, currentValue = param.currentValue, onChange = param.onChange, tapQuestionId = param.tapQuestionId, _param_isDisabled = param.isDisabled, isDisabled = _param_isDisabled === void 0 ? false : _param_isDisabled;
    var isDemographic = !!demographicQuestions;
    var questions = isDemographic ? demographicQuestions : tapQuestions;
    var activeComparison = currentValue && questions[currentValue];
    var onClear = useCallback(function(e) {
        e.stopPropagation();
        onChange('');
    }, [
        onChange
    ]);
    return /*#__PURE__*/ React.createElement(Menu, {
        matchWidth: true,
        autoSelect: false
    }, /*#__PURE__*/ React.createElement(MenuButton, _object_spread({
        isDisabled: isDisabled,
        as: Button,
        flexGrow: 1,
        minW: '200px',
        variant: 'outline',
        colorScheme: 'gray',
        color: 'gray.700',
        maxW: {
            base: 'none',
            md: 'calc(50% - 20px)'
        },
        _hover: {
            bg: 'blue.50'
        },
        rightIcon: /*#__PURE__*/ React.createElement(Icon, {
            color: "gray.600",
            boxSize: 5,
            icon: icons.fi.ChevronDown
        })
    }, activeComparison && {
        borderColor: 'blue.500',
        bg: 'blue.50'
    }), /*#__PURE__*/ React.createElement(Flex, {
        w: "full",
        align: "center",
        justify: "space-between"
    }, /*#__PURE__*/ React.createElement(Text, {
        textAlign: "left",
        lineHeight: "normal",
        isTruncated: true,
        w: "calc(100% - 30px)"
    }, (activeComparison === null || activeComparison === void 0 ? void 0 : activeComparison.name) || (isDemographic ? 'Compare against demographic' : 'Compare against Question')), activeComparison && /*#__PURE__*/ React.createElement(IconButton, {
        'aria-label': 'Remove current comparison',
        as: Center,
        variant: 'square',
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        size: 5,
        p: 1,
        color: 'gray.600',
        position: 'absolute',
        onClick: onClear,
        right: '40px',
        pointerEvents: 'all',
        zIndex: '2',
        _hover: {
            bg: 'error.100',
            color: 'error.600'
        },
        icon: /*#__PURE__*/ React.createElement(Icon, {
            boxSize: 5,
            icon: icons.fi.X
        })
    }))), /*#__PURE__*/ React.createElement(MenuList, null, /*#__PURE__*/ React.createElement(MenuOptionGroup, {
        value: currentValue || null,
        type: "radio"
    }, Object.entries(questions || {}).map(function(param) {
        var _param = _sliced_to_array(param, 2), questionId = _param[0], question = _param[1];
        if (questionId === "tq_".concat(tapQuestionId)) return null;
        return /*#__PURE__*/ React.createElement(MenuItemOption, {
            key: questionId,
            value: questionId,
            flexWrap: "wrap",
            isChecked: questionId === currentValue,
            onClick: function() {
                return onChange(questionId);
            },
            sx: {
                'span:nth-of-type(2)': {
                    width: '0'
                }
            }
        }, question.name);
    }))));
};
